module.exports = __webpack_public_path__ + "img/Prizes.a15a79ad.svg";